import { render, staticRenderFns } from "./parentDailyReport.vue?vue&type=template&id=6a0ab738&scoped=true"
import script from "./parentDailyReport.vue?vue&type=script&lang=ts"
export * from "./parentDailyReport.vue?vue&type=script&lang=ts"
import style0 from "./parentDailyReport.vue?vue&type=style&index=0&id=6a0ab738&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0ab738",
  null
  
)

export default component.exports